import type { ControlPosition, IControl } from 'maplibre-gl';
import { createNewElement } from '../../../lib/createElements';
import { directionType } from '../../../types/components/moveControlBtn';
import ReactGA from 'react-ga4';


/* ****************
 * 左右移動ボタンのコントロール
 * ****************/
export class MoveControlBtn implements IControl {
  private container: HTMLDivElement | undefined;
  private map: maplibregl.Map | undefined;
  private show3dDem: boolean = false;
  private distanceX: number;
  private distanceY: number;
  private directionArr: directionType[] = ['up', 'left', 'right', 'down'];

  constructor() {
    this.handleClick = this.handleClick.bind(this);
    this.distanceX = (window.innerWidth - 364) / 2;
    this.distanceY = window.innerHeight / 2;
  }

  /* ****************
   * 移動ボタンクリック時の処理
   * ****************/
  handleClick(direction: directionType) {
    if(!this.map) { return; }

    let offsetX = 0;
    let offsetY = 0;

    switch (direction) {
        case 'up':
            offsetY = -this.distanceY;
            break;
        case 'down':
            offsetY = this.distanceY;
            break;
        case 'left':
            offsetX = -this.distanceX;
            break;
        case 'right':
            offsetX = this.distanceX;
            break;
    }

    this.map.panBy([offsetX, offsetY], { duration: 500 });
    this.show3dDem = !this.show3dDem;


    //【GoogleAnalytics】移動 クリックトラッキング
    ReactGA.event({
      category: "button_click", // カテゴリ（任意の名前）
      action: "click",          // イベントの種類
      label: `地図ボタン/移動ボタン${direction as string}`,       // ボタン名
    });
  }

  /* ****************
   * onAdd
   * ****************/
  onAdd(map: maplibregl.Map) {
    this.map = map;

    // 表示・非表示の切り替えボタンを追加
    const btn = this.directionArr.map((label: directionType) => { 
      return (createNewElement('button', { 
        className: 'maplibregl-ctrl-icon',
        childArr: [createNewElement('span', { 
          className: 'button',
          textContent: label === 'left' ? '←' : label === 'right' ? '→' : label === 'up' ? '↑' : '↓',
          ariaHidden: 'true'
        })],
        dataE2eTestId: `move-control-btn-${label}`,
        onClick: () => { this.handleClick(label); }
      }));
    });

    const container = createNewElement('div', { 
      className: 'maplibregl-ctrl maplibregl-ctrl-group',
      childArr: [ ...btn ]
    });

    // ボタンクリック時の処理
    this.container = container as HTMLDivElement;

    return this.container;
  }

  /* ****************
   * onRemove
   * ****************/
  onRemove() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.map = undefined;
  }

  getDefaultPosition(): ControlPosition {
    return 'top-right';
  }
}
